import { Component, Input, OnChanges, SimpleChanges, ViewChild, inject } from '@angular/core';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import { MatButtonModule } from '@angular/material/button';
import { NgFor } from '@angular/common';
import {MsalService} from "@azure/msal-angular";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [MatStepperModule, NgFor, MatButtonModule]
})
export class SidebarComponent implements OnChanges {
    private readonly router = inject(Router);
    private readonly msalService = inject(MsalService);


    @ViewChild('stepper') stepperInscription: MatStepper;
    @Input() nbStep: number;
    @Input() step: number;

    version: string = environment.appVersion === '0.0.0' ? 'Développement' : environment.appVersion;

    goBack() {
        // Change edited state of actual step to uncompleted
        this.stepperInscription.selected.completed = false;
        // Change to previous header step
        this.stepperInscription.previous();
    }

    goForward() {
        // Change edited state of actual step to completed
        this.stepperInscription.selected.completed = true;
        // Change to next header step
        this.stepperInscription.next();
    }

    ngOnChanges(change: SimpleChanges) {
        for (const propName in change) {
            if (change[propName].currentValue > change[propName].previousValue &&
                change[propName].previousValue < this.nbStep) {
                this.goForward();
            } else if (change[propName].currentValue < change[propName].previousValue &&
                change[propName].previousValue > 0) {
                this.goBack();
            }
        }
    }

    goToLogin() {
      this.msalService.logout();
        this.router.navigate(['/login']).then();
    }
}
